import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute as productRootRoute } from '@/product/root'
import { canReadCommunity } from '@/product/community/access'

export const rootRoute = createRoute({
    getParentRoute: () => productRootRoute,
    path: '/community',
    beforeLoad: async () => {
        if (!canReadCommunity()) {
            throw redirect({ to: '/' })
        }
    },
})
